// extracted by mini-css-extract-plugin
export default {"aside":"AsideLeft_aside__hWYWa","aside__max":"AsideLeft_aside__max__7ux7X","aside__min":"AsideLeft_aside__min__Ern7L"};